import styled, { css } from 'styled-components'

import { Typography } from '@/components/ui/typography'
import { withBorder } from '@/theme/utils'

export const OrderSummaryModuleContent = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space['24']};
  `,
)

export const ProductsWrapper = styled.div(
  () => css`
    display: flex;
    flex-direction: column;
  `,
)

export const ProductRow = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space['4']};
    padding-bottom: ${withBorder(theme, 8)};
    border-bottom: ${theme.border.size['1']} solid ${theme.colors.gray400};

    &:not(:first-child) {
      padding-top: ${theme.space['8']};
    }
  `,
)

export const CartMainText = styled(Typography)(
  () => css`
    font-size: 1.4rem;
    line-height: 1.5rem;
    font-weight: 500;
  `,
)

export const Note = styled(Typography)(
  () => css`
    line-height: normal;
  `,
)

export const OrderNoteContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space['4']};
  `,
)

export const PricesContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space['8']};
  `,
)

export const Texts = styled.div(
  ({ theme }) => css`
    display: flex;
    justify-content: space-between;
    gap: ${theme.space['8']};
  `,
)
